import React from "react";

function AddCohostIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      {...props}
    >
      <path
        // fill="#9E9EA7"
        fillRule="evenodd"
        d="M3.484 9.52l.61 4.88H2.6V16h9.6v-1.6h-1.494l.61-4.88A3.201 3.201 0 0013.8 6.4v-.8a.8.8 0 00-.8-.8H8.2V2.986A1.599 1.599 0 007.4 0a1.6 1.6 0 00-.8 2.986V4.8H1.8a.8.8 0 00-.8.8v.8a3.201 3.201 0 002.484 3.12z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default AddCohostIcon;
